import styleInject from '../../../node_modules/style-inject/dist/style-inject.es.js';

var css_248z = ".styles-module_wrapper__E1tpL {\n  position: relative;\n  display: inline-flex;\n  justify-content: center;\n  align-items: center;\n  border-radius: 100%;\n}\n\n.styles-module_gravatar__3i847 {\n  position: absolute;\n  top: 0;\n  left: 0;\n  width: 100%;\n  height: 100%;\n  border-radius: 100%;\n}";
var styles = {"wrapper":"styles-module_wrapper__E1tpL","gravatar":"styles-module_gravatar__3i847"};
styleInject(css_248z);

export { styles as default };
//# sourceMappingURL=styles.module.scss.js.map
